import { HeatSeries } from "src/store/api/generatedApi";
import { equalSets } from "../utils";
import { Box } from "@mui/material";
import { TrafficLight, getTrafficLightColor } from "./TrafficLight";

export const StrikeTrafficLightCell = ({
  row,
  ignoredMaterials,
}: {
  row: HeatSeries;
  ignoredMaterials: Set<string>;
}) => {
  const liftStrikes = row.mixes
    .find(
      (mix) =>
        mix.source === "ScrapEye" &&
        equalSets(new Set(mix.ignored_materials), ignoredMaterials)
    )
    ?.summary_data.find(({ name }) => name === "liftStrikes")?.value;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <TrafficLight color={getTrafficLightColor(liftStrikes)} />
    </Box>
  );
};
